import { render, staticRenderFns } from "./ControleGrupo.vue?vue&type=template&id=cfe06790"
import script from "./ControleGrupo.vue?vue&type=script&lang=js"
export * from "./ControleGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports